<template>
  <div>
    <div v-if="item.isLinkProduct==-1">
      <hotel-resource-left :productObj="item" :showTag="false" @exclusiveAddYsP="exclusiveAddYsP"></hotel-resource-left>
      <div class="contentContainer" v-if="item.isOpen">
        <div class="boxContainer" v-for="(item1, index) in item.customList" :key="'detailResponses' + index">
          <div class="boxContainer-title" @click.stop="item1.isOpen = !item1.isOpen">
            <span>{{ item1.budgetType==''?'点击后方下拉查看更多价格 ':item1.budgetType }}</span>
            <div style="    width: 1.17rem;display: flex;justify-content: space-between;">
              <span style="width: 0.6rem;text-align: end;">{{ item1.price }}{{ item1.currency }}起</span>
              <span><i style="font-size: 0.2rem;" :class="item1.isOpen?'el-icon-caret-top':'el-icon-caret-bottom'"></i></span>
            </div>
          </div>
          <div v-show="item1.isOpen">
            <div v-for="(item2, index1) in item1.children" :key="index1">
              <div class="boxContainer-content">
                <div class="item" style="display: flex; margin-left: 0.13rem; width:20%;" @click="stockDetail(item2)"> {{ item2.productNameCn }}</div>
                <el-tooltip class="item" effect="dark" :content="item2.productDesc" placement="top">
                  <span class="sp1 specialone">
                    <span v-if="item2.stockDesc&&item2.stockDesc!=''">{{item2.stockDesc}}&nbsp;&nbsp;</span>
                    {{ item2.productDesc }}
                  </span>
                </el-tooltip>
                <el-popover width="300" trigger="hover">
                  <p>
                    <span>同业价:{{item2.priceList[0].toBPrice}}{{ item2.priceList[0].currency }}&nbsp;&nbsp;</span>
                    <span>直客价:{{item2.priceList[0].toCPrice}}{{ item2.priceList[0].currency }}&nbsp;&nbsp;</span>
                    <span>门市价:{{item2.priceList[0].marketPrice}}{{ item2.priceList[0].currency }}</span>
                  </p>
                  <div class="item price" slot="reference" @click="changePrice(item,item1,item2)">
                    {{ item2.priceList[0].price }}{{ item2.priceList[0].currency }}{{ item2.priceList[0].useTime}}/{{item2.priceList[0].priceCompany}}
                  </div>
                </el-popover>
                <div class="item" style="margin-right: 0.1rem; text-align: right">
                  <el-input v-model="item2.checkNumber" style="width: 0.6rem" size="mini"></el-input>
                  <span>&nbsp;{{item2.priceList[0].priceCompany}}</span>
                </div>
                <div class="item add">
                  <span class="qiang">抢</span>
                  <i class="el-icon-circle-plus-outline" @click="checkHotelYsTime(item, item2)" ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p style="text-align: right;    font-size: 0.25rem;">
          <i class="el-icon-caret-top" @click.stop="item.isOpen = false"></i>
        </p>
      </div>
    </div>
    <div v-else>
      <div class="zhafeiDiv">
        <div>
          <span class="incidentalCard-span">杂费</span>
          <b class="incidentalCard-title">{{ item.nameCn }}</b>
        </div>
        <div class="showCard-tag-div">
          <div class="showCard-tag">
            <div>
              <i @click.stop="openclick(item)" :class="item.isOpen?'el-icon-caret-top':'el-icon-caret-bottom'"></i>
            </div>
            <div>
              <b>{{ item.price }}</b>
              <b style="font-size:0.12rem;">{{ item.currency }}</b>
              <label>起</label>
            </div>
          </div>
        </div>
      </div>
      <div class="contentContainer" v-if="item.isOpen">
        <div class="boxContainer" v-for="(item1, index) in item.customList" :key="'detailResponses' + index">
          <div v-for="(item2, index1) in item1.children" :key="index1">
            <div class="boxContainer-content">
              <div class="item" style="display: flex; margin-left: 0.13rem; width:20%;" @click="stockDetail(item2)"> {{ item2.productNameCn }}</div>
              <el-tooltip class="item" effect="dark" :content="item2.productDesc" placement="top">
                <span class="sp1 specialone">
                  <span v-if="item2.stockDesc&&item2.stockDesc!=''">{{item2.stockDesc}}&nbsp;&nbsp;</span>
                  {{ item2.productDesc }}
                </span>
              </el-tooltip>
              <el-popover width="300" trigger="hover">
                <p>
                  <span>同业价:{{item2.priceList[0].toBPrice}}&nbsp;&nbsp;</span>
                  <span>直客价:{{item2.priceList[0].toCPrice}}&nbsp;&nbsp;</span>
                  <span>门市价:{{item2.priceList[0].marketPrice}}</span>
                </p>
                <div class="item price" slot="reference" @click="changePrice(item,item1,item2)">
                  {{ item2.priceList[0].price }}{{ item2.priceList[0].currency }}{{ item2.priceList[0].useTime}}/{{item2.priceList[0].priceCompany}}
                </div>
              </el-popover>
              <div class="item" style="margin-right: 0.1rem; text-align: right">
                <el-input v-model="item2.checkNumber" style="width: 0.6rem" size="mini"></el-input>
                <span>&nbsp;{{item2.priceList[0].priceCompany}}</span>
              </div>
              <div class="item add">
                <span class="qiang">抢</span>
                <i class="el-icon-circle-plus-outline" @click="checkHotelYsTime(item, item2)" ></i>
              </div>
            </div>
          </div>
        </div>
        <p style="text-align: right;    font-size: 0.25rem;">
          <i class="el-icon-caret-top" @click.stop="item.isOpen = false"></i>
        </p>
      </div>
    </div>
    <add-hotel-product-dialog v-if="item.state===0||item.isLinkProduct==0" ref="addProductDialog"></add-hotel-product-dialog>
    <add-meal-product-dialog v-else-if="item.state===4||item.isLinkProduct==4" ref="addProductDialog"></add-meal-product-dialog>
    <add-traffic-product-dialog v-else ref="addProductDialog"></add-traffic-product-dialog>
    <create-product-dialog ref="createProduct" :keyStr="keyStr"></create-product-dialog>
    <el-dialog :visible.sync="dialogVisible" width="40%" :append-to-body='true'>
      <stock-detail :stockDetailObj="stockDetailObj"></stock-detail>
    </el-dialog>
  </div>
</template>

<script>
import StockDetail from '../../leftMoudle/dialog/stockDetail.vue'
import addHotelProductDialog from './addProductDialog/addHotelProductDialog.vue'
import AddMealProductDialog from './addProductDialog/addMealProductDialog.vue'
import addTrafficProductDialog from './addProductDialog/addTrafficProductDialog.vue'
import createProductDialog from './addProductDialog/createProductDialog.vue'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import Api from '@/components/Api/index.js'
export default {
  components:{hotelResourceLeft, addHotelProductDialog,addTrafficProductDialog, AddMealProductDialog,createProductDialog, StockDetail},
  props:{
    item:{
      type:Object,
      default:()=>{return {}}
    },
    chenckBudgteObj:{
      type:Object,
      default:()=>{return {}}
    },
    keyStr:{
      type:String,
      default:''
    }
  },
  methods:{
    exclusiveAddYsP(){
      this.$set(this.item, 'isOpen', true)
      this.$set(this.item.customList[0],'isOpen',true)
    },
    checkHotelYsTime(item,item2){
      this.$refs.addProductDialog.openDialog(item,item2,this.chenckBudgteObj,this.keyStr)
    },
    changePrice(item,item1,item2){
      this.$refs.createProduct.beforeOpen(item,item2,this.chenckBudgteObj)
    },
    openclick(item){
      this.$set(item,'isOpen',!item.isOpen)
    },
    stockDetail(item){
      this.dialogVisible=true
      new Api('resource').stockDetail({stockIds:[item.stockId],productType:1}).then(res => {
        if (res.status == 200) {
          this.stockDetailObj = res.data[0]
        }
      })
    }
  },
  data(){
    return{
      stockDetailObj:{},
      dialogVisible:false
    }
  }
}
</script>

<style lang="scss" scoped>
.contentContainer{
  font-size: 0.12rem;
  .boxContainer{
    .boxContainer-title{
      color: #000;
      font-weight: bold;
      padding-top: 0.1rem;
      margin-left: 0.1rem;
      display: flex;
      justify-content: space-between;
      padding-right: 4px;
      
    }
    .boxContainer-content{
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      .item{
        margin-right: 0.05rem;
      }
      .specialone{
        width: 35%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .price{
        color: #ff0000;
        font-weight: bold;
        font-size: 0.14rem;
        width: 0.9rem;
        cursor: pointer;
        text-decoration: underline;
      }
      .add{
        margin-left: 0.2rem;
        .qiang{
          font-size: 0.18rem;
          font-weight: bold;
          box-shadow: 0px 0px 4px 0px #333;
          border-radius: 50%;
          color: red;
          text-align: center;
          display: inline-block;
          width: 0.26rem;
          height: 0.26rem;
          vertical-align: text-bottom;
          margin-right: 0.05rem;
          line-height: 0.26rem;
        }
        i{
          font-size: 0.3rem;
        }
      }
    }
  }
}
.changePriceBox{
  text-align: center;
  >div{
    display: flex;
    align-items: center;
    margin-bottom: 0.1rem;
    justify-content: center;
    >div{
      width: 1rem;
      margin-left: 0.1rem;
    }
  }
}
.zhafeiDiv{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 3px solid #db4e1a;
  .incidentalCard-span{
    background: #F0F4F4;
    padding: 0.05rem 0.15rem;
    margin: 0 0.15rem 0.1rem 0.15rem;
    display: inline-block;
  }
  .showCard-tag{
    padding: 0 0.04rem;
    height: 0.35rem;
    background: #db4e1a;
    display: flex;
    align-items: center;
    margin-top: 0.2rem;
    justify-content: space-between;
    cursor: pointer;
    color: #fff; 
    width: 1.3rem;
    >div{
      >i{
        font-size: 0.25rem;
      }
      >b{
        font-size: 0.18rem;
      }
      >label{      
        font-size: 0.12rem;
        padding-right: 3px;
      }
    }
  }
}

</style>